// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2prwI","bigColWidth":"Table_bigColWidth__L0qM1","biggerColWidth":"Table_biggerColWidth__kq9Em","row":"Table_row__32CfM","col":"Table_col__2ET5C"};